import React, {  useImperativeHandle, forwardRef,useState, useEffect } from "react";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { InputTextarea } from "primereact/inputtextarea";
import { Chips } from "primereact/chips";
import { Checkbox } from "primereact/checkbox";
import { Message } from "primereact/message";
import axios from "axios";
import { triggerAlert } from "utils/CommonFunctions";

const NotesContact1  = forwardRef(({ selectedCustomers=[], fullNameTemplate, uniqueUserId }, ref) => {
  const [visibleLinkJob, setVisibleLinkJob] = useState(false);
  const [popchecked, setPopchecked] = useState(false);
  const [currentDateTime, setCurrentDateTime] = useState(new Date());
  const [notes, setNotes] = useState("");
  const [displayedCustomers, setDisplayedCustomers] = useState([]);
  const [notesError, setNotesError] = useState("");

    useImperativeHandle(ref, () => ({
      openLinkJobModal: () => setVisibleLinkJob(true),
    }));
  const handlePopupCheckbox = (e) => {
    setPopchecked(e.checked);
  };

  const resetForm = () => {
    setNotes("");
    setPopchecked(false);
    setCurrentDateTime(new Date());
    setNotesError("");
  };

  const handleAddNote = async () => {
    if (!notes.trim()) {
      setNotesError("Notes cannot be empty");
      return;
    }

    const payload = {
      contact_id: displayedCustomers?.map((customer) => customer.id).join(','),
      notes: notes,
      date: currentDateTime.toISOString(),
      user_ids: uniqueUserId,
      private: popchecked,
    };
    try {
    const response = await axios.post(`/api/v1/notes/`, payload);
    console.log("Payload for adding note:", response);
    triggerAlert('success', 'Success', 'Note added successfully!');
  } catch (error) {
    console.error("Error adding note:", error);
    triggerAlert('error', 'Error', 'Failed to add note');
  } finally {
    setVisibleLinkJob(false);
    resetForm();
  }
};

  useEffect(() => {
    setDisplayedCustomers(selectedCustomers);
  }, [selectedCustomers]);

  const handleHideDialog = () => {
    setVisibleLinkJob(false);
    resetForm();
  };

  const selectedCustomerNames = displayedCustomers?.length > 0
    ? displayedCustomers
        .map((customer) => `${fullNameTemplate(customer)}`)
        .join(", ")
    : "";

  return (
    <React.Fragment>
      <button
        type="button"
        className="btn btn-secondary icons-btn me-1"
        onClick={() => setVisibleLinkJob(true)}
      >
        <i className="pi pi-file"></i>
      </button>

      <Dialog
        header={`Note - ${selectedCustomerNames}`}
        visible={visibleLinkJob}
        onHide={handleHideDialog}
        style={{ width: "50vw" }}
        breakpoints={{ "960px": "75vw", "641px": "100vw" }}
        className="link-candidates"
      >
        <Row>
          <Col lg={6}>
            <div className="field">
              <label htmlFor="candidate" className="block mb-0">
                Type
              </label>
              <InputText
                id="candidate"
                value="Note"
                readOnly
                className="w-full"
                placeholder="Note"
                disabled
              />
            </div>
          </Col>

          <Col lg={6}>
            <div className="field">
              <label htmlFor="currentDateTime" className="block mb-0">
                Date
              </label>
              <Calendar
                id="currentDateTime"
                value={currentDateTime}
                onChange={(e) => setCurrentDateTime(e.value)}
                showTime
                showIcon
                dateFormat="yy-mm-dd"
                hourFormat="12"
                readOnlyInput
                className="w-full"
              />
            </div>
          </Col>

          <Col lg={12}>
            <div className="field">
              <label htmlFor="job" className="block mb-0">
                Contact
              </label>
              <InputText
                id="job"
                value={selectedCustomerNames}
                placeholder=""
                className="w-full"
                disabled
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <div className="field">
              <label htmlFor="notes" className="block mb-0">
                Notes
              </label>
              <InputTextarea
                id="notes"
                value={notes}
                onChange={(e) => {
                  setNotes(e.target.value);
                  setNotesError("");
                }}
                rows={3}
                cols={20}
                className="w-full"
                placeholder="Enter your notes here..."
                autoResize
              />
              {notesError && <Message severity="error" text={notesError} />}
            </div>
          </Col>
        </Row>
        <Row className="align-items-center">
          <Col lg={2}>
            <div className="d-flex align-items-center">
              <Checkbox
                inputId="checkbox"
                checked={popchecked}
                onChange={handlePopupCheckbox}
              />
              <label htmlFor="checkbox" className="ms-2 mt-2">
                Private
              </label>
            </div>
          </Col>
          <Col lg={6}>
            <div className="field notes-chip">
              <label htmlFor="userId" className="block mb-0">
                User IDs
              </label>
              <InputText
                value={uniqueUserId}
                readOnly
                className="w-full"
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <div className="d-flex justify-content-end">
              <button
                type="button"
                className="btn btn-primary me-2 btn-main"
                onClick={handleAddNote}
              >
                Add Note
              </button>
            </div>
          </Col>
        </Row>
      </Dialog>
    </React.Fragment>
  );
});

export default NotesContact1;
